import { createStore } from 'vuex'
// import dayjs from 'dayjs'

const endpointURL = 'https://br.collab-tv.com'
const currentWeatherEndpointURL = 'https://api.openweathermap.org/data/2.5/weather?appid=dd5fdc1895efbc6ac834746a067dc493&units=metric'
const version = 'v2.3.4 - 16/02/2023'
// const currentTimeEndpointURL = 'https://www.timeapi.io/api/Time/current/coordinate'

export default createStore({
  state: {

    loadedToken: false,
    loadedDevice: false,
    loadedSlidesData: false,
    loadedSlidesMedia: false,

    updatingSlides: false,
    updatingSlidesError: false,
    updatingSlidesErrorCount: 0,

    updatingConnectionErrorCount: 0,

    lastErrorMessage: '',
    lastErrorMessageTime: '',
    lastErrorDetails: '',

    lastContentUpdate: null,

    slowConnection: false,

    currentTime: null,

    currentWeatherData: null,

    currentSlide: 0,

    auth: {
      username: null,
      accessToken: null,
      refreshToken: null,
      accessTokenExp: null,
      refreshTokenExp: null
    },

    device: {
      code: null,
      description: null,
      city: null,
      site: null,
      openWeatherMapId: null
    },

    slides: null,

    slidesMediaCount: 0,

    slideLoadedMediaCount: 0
  },
  getters: {
  },
  mutations: {
    loadedToken(state, value){
      state.loadedToken = value
    },
    loadedDevice(state, value){
      state.loadedDevice = value
    },
    loadedSlidesData(state, value){
      state.loadedSlidesData = value
    },
    loadedSlidesMedia(state, value){
      state.loadedSlidesMedia = value
    },
    updatingSlides(state, value){
      state.updatingSlides = value
    },
    updatingSlidesError(state, value){
      state.updatingSlidesError = value
    },
    updatingSlidesErrorCount(state, value){
      state.updatingSlidesErrorCount = value
    },
    updatingSlidesErrorCountAdd(state, value){
      state.updatingSlidesErrorCount = state.updatingSlidesErrorCount + value
    },
    updatingConnectionErrorCount(state, value) {
      state.updatingConnectionErrorCount = value
    },
    updatingConnectionErrorCountAdd(state, value) {
      state.updatingConnectionErrorCount += value
    },
    lastContentUpdate(state, value){
      state.lastContentUpdate = value
    },
    lastErrorMessage(state, value){
      state.lastErrorMessage = value
    },
    lastErrorMessageTime(state, value){
      state.lastErrorMessageTime = value
    },
    lastErrorDetails(state, value){
      state.lastErrorDetails = value
    },
    slowConnection(state, value){
      state.slowConnection = value
    },
    currentTime(state, value){
      state.currentTime = value
    },
    currentWeatherData(state, value){
      state.currentWeatherData = value
    },
    currentSlide(state, value){
      state.currentSlide = value
    },
    auth(state, value){
      state.auth = value
    },
    device(state, value){
      state.device = value
    },
    slides(state, value){
      state.slides = value
    },
    slidesMediaCount(state, value){
      state.slidesMediaCount = value
    },
    slideLoadedMediaCount(state, value){
      state.slideLoadedMediaCount = value
    }
  },
  actions: {
    async sendConnectionRefresh({ state, commit, dispatch }) {
      try {

        const config = {
          code: state.device.code,
          lastContentUpdateTime: state.lastContentUpdate,
          tvTime: new Date(),
          tvVersion: version,
          tvTotalSlides: state.slidesMediaCount,
          tvSlidesNames: state.slides.map(item => `${item.title} (${item.start_date} - ${item.end_date})`),
          lastErrorMessage: state.lastErrorMessage,
          lastErrorMessageTime: state.lastErrorMessageTime,
          lastErrorDetails: state.lastErrorDetails,
          tvCurrentSlide: state.slides[state.currentSlide].title || null
        }

        let response = await fetch(`${endpointURL}/connection`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': state.auth.accessToken
          },
          body: JSON.stringify(config)
        })

        if (response.status !== 200) {
          if (response.status === 401) {
            throw new Error('Unauthorized device. Please check the code.')
          }
          throw new Error('Unknown error. Please contact support.')
        }

        commit('updatingSlidesError', false)
        commit('updatingConnectionErrorCount', 0)
      }catch(error) {
        dispatch('registerError', error)

        commit('updatingSlidesError', true)
        commit('updatingConnectionErrorCountAdd', 1)

      } finally {
        if (state.updatingConnectionErrorCount > 10) {
          commit('updatingSlidesError', true)
        }
      }
    },

    async authenticateDevice({ commit, dispatch, state }, code) {
      try {
        let response = await fetch(`${endpointURL}/tv`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ code })
        })

        if (response.status !== 200) {
          if (response.status === 401) {
            throw new Error('Unauthorized device. Please check the code.')
          }
          throw new Error('Unknown error. Please contact support.')
        }

        let data = await response.json()
  
        let auth = {
          username: data.username,
          accessToken: data.token,
          refreshToken: data.rToken,
          accessTokenExp: null,
          refreshTokenExp: null
        }
  
        let device = {
          code: data.code,
          description: data.description,
          city: data.city,
          site: data.site,
          openWeatherMapId: data.openweathermap_id
        }
  
        commit('auth', auth)
        commit('device', device)
        commit('loadedToken', true)
        commit('loadedDevice', true)
  
        return Promise.resolve()
      } catch (error) {
        error.details = {
          message: 'Erro ao tentar autenticar o device',
          device: state.device
        }

        dispatch('registerError', error)
        throw error
      }
    },

    async loadSlides({ state, commit, dispatch }) {
      try {
        let response = await fetch(`${endpointURL}/feed`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': state.auth.accessToken
          },
          body: JSON.stringify({ site: state.device.site })
        })

        if (response.status !== 200) {
          throw new Error('Ocorreu um erro ao carregar os slides do mural')
        }

        let data = await response.json()
  
        let slides = data.Slides
        let slidesMediaCount = 0
        for(let slide of slides){
          // eslint-disable-next-line
          for(let media of slide.medias){
            slidesMediaCount++
          }
        }

        commit('slidesMediaCount', slidesMediaCount)

        await dispatch('loadSlidesMedia', slides)
  
        commit('slides', slides)
  
        return Promise.resolve()
      } catch (error) {
        error.details = {
          message: 'Erro ao tentar carregar os slides',
          device: state.device
        }

        dispatch('registerError', error)
        throw error
      }
    },

    async loadSlidesMedia({ commit, dispatch, state }, slides) {

      try {
        if (state.slides) {
          for(const slide of state.slides) {
            for (const media of slide.medias) {
              console.log('Revoking URL of slide: ' + slide.title)
              URL.revokeObjectURL(media.localURL)
            }
          }
        }
      } catch (error) {
        dispatch('registerError', error)
      }
      
      const promises = []
      let counter = 1
      commit('slideLoadedMediaCount', counter)
      try {
        for (const slide of slides) {
          for(const media of slide.medias) {
            const mediaPromise = new Promise((resolve, reject) => {
              console.log('Downloading ' + media.url)
              fetch(media.url)
                .then((response) => response.blob())
                .then((data) => {
                  media.localURL = URL.createObjectURL(data)
                  commit('slideLoadedMediaCount', counter++)
                  resolve()
                })
                .catch(error => {
                  reject(error)
                })
            })

            promises.push(mediaPromise)
          }
        }

        await Promise.all(promises)

        commit('slideLoadedMediaCount', 0)
        commit('loadedSlidesData', true)
        commit('updatingSlides', false)

        return Promise.resolve()
      } catch (error) {
        error.details = {
          message: 'Erro ao tentar carregar as midias dos slides',
          device: state.device
        }

        dispatch('registerError', error)
        commit('updatingSlidesErrorCountAdd', 1)
        throw error
      }
    },

    async loadCurrentWeather({ state, commit, dispatch }){
      try {
        let response = await fetch(`${currentWeatherEndpointURL}&id=${state.device.openWeatherMapId}`)

        if (response.status !== 200) {
          commit('currentWeatherData', null)
          throw new Error('Não foi possível capturar os detalhes do tempo')
        }

        let data = await response.json()

        commit('currentWeatherData', data)

        return Promise.resolve()
      } catch (error) {
        error.details = {
          message: 'Erro ao tentar carregar os dados de tempo',
          device: state.device
        }

        dispatch('registerError', error)
        throw error
      }
    },

    async loadCurrentTime({ /*state,*/ commit, dispatch }) {
      try {
        /* let latitude = state.currentWeatherData.coord.lat
        let longitude = state.currentWeatherData.coord.lon

        if (!latitude && !longitude) return
        let response = await fetch(`${currentTimeEndpointURL}?latitude=${latitude}&longitude=${longitude}`)

        if (response.status !== 200) {
          commit('currentTime', new Date().toISOString())
          return Promise.resolve()
        }

        let data = await response.json()

        commit('currentTime', data.dateTime) */

        commit('currentTime', new Date().toISOString())

        return Promise.resolve()
      } catch (error) {
        dispatch('registerError', error)
        commit('currentTime', new Date().toISOString())
        return Promise.resolve()
      }
    },

    async registerError({ commit }, error) {
      try {
        console.log(error)

        commit('lastErrorMessage', JSON.stringify({
          name: error.name,
          message: error.message,
          stack: error.stack
        }))
        commit('lastErrorDetails', JSON.stringify(error.details))
        commit('lastErrorMessageTime', new Date().toISOString())
      } catch (error) {
        console.log(error)
      }
    }
  },
  modules: {
  }
})
